import React, { useState, useEffect } from 'react';
import { styles } from '../styles/ComfyOutput';
import DoubleRightIcon from "../images/icons/white-double-right.svg";
import DoubleLeftIcon from "../images/icons/white-double-left.svg";
import GreyDoubleRightIcon from "../images/icons/grey-double-right.svg";
import GreyDoubleLeftIcon from "../images/icons/grey-double-left.svg";
import Logo from "../images/logo_light_grey.png";

/**
 * ComfyOutputLayout Component
 * Presentation component for ComfyOutput page layout - styled to match My Collection page
 */
const ComfyOutputLayout = ({ 
  category, 
  sortMethod, 
  onCategoryChange, 
  onSortMethodChange,
  loading = false,
  onRebuildDatabase,
  onRegenerateVideoThumbnails,
  page = 0,
  totalItems = 0,
  totalStoredItems = 0,
  onPageChange,
  columnClass = "cols-4",
  onColumnClassChange,
  children
}) => {
  const [showAll, setShowAll] = useState(false);
  const [displayedItems, setDisplayedItems] = useState(totalItems);
  const [displayedTotal, setDisplayedTotal] = useState(totalStoredItems);

  // Debug received props
  useEffect(() => {
    console.log("ComfyOutputLayout received counts:", { totalItems, totalStoredItems });
    
    // Update local state with received props
    setDisplayedItems(totalItems);
    setDisplayedTotal(totalStoredItems);
  }, [totalItems, totalStoredItems]);

  const handleToggleShowAll = () => {
    setShowAll(!showAll);
    if (onPageChange) {
      onPageChange(0); // Reset to first page when toggling view
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>
        <span className={styles.headerTitle}>ComfyUI Output</span>
        <hr className={styles.divider} />
        
        {/* Sort method dropdown */}
        <select 
          className={styles.select}
          value={sortMethod}
          onChange={(e) => onSortMethodChange(e.target.value)}
        >
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
        </select>
        
        {/* Category/filter dropdown */}
        <select 
          className={styles.select}
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
        >
          <option value="all">All</option>
          <option value="image">Images</option>
          <option value="video">Videos</option>
          <option value="audio">Audio</option>
        </select>

        {/* Action buttons */}
        <button 
          className={styles.buttonDanger} 
          onClick={onRegenerateVideoThumbnails}
        >
          Regenerate Thumbnails
        </button>
        <button 
          className={styles.buttonDanger} 
          onClick={onRebuildDatabase}
        >
          Rebuild Database
        </button>
        
        {/* Pagination and display controls */}
        <div className={styles.controlsContainer}>
          {!showAll ? (
            <>
              {/* {page > 0 ? (
                <button 
                  className={styles.paginationButton} 
                  onClick={() => onPageChange(page - 1)}
                >
                  <img src={DoubleLeftIcon} alt="Previous Page" className="h-10" />
                </button>
              ) : (
                <button className={styles.disabledPaginationButton}>
                  <img src={GreyDoubleLeftIcon} alt="Previous Page" className="h-10" />
                </button>
              )} */}
              
              {/* <div className={styles.pageNumberContainer}>{page + 1}</div> */}
              
              {/* {(page * 20 + 20) < totalStoredItems ? (
                <button 
                  className={styles.paginationButton} 
                  onClick={() => onPageChange(page + 1)}
                >
                  <img src={DoubleRightIcon} alt="Next Page" className="h-10" />
                </button>
              ) : (
                <button className={styles.disabledPaginationButton}>
                  <img src={GreyDoubleRightIcon} alt="Next Page" className="h-10" />
                </button>
              )} */}
            </>
          ) : null}
          
          {/* <button 
            className={styles.toggleButton} 
            onClick={handleToggleShowAll}
          >
            Show {showAll ? "Pages" : "All"}
          </button> */}
          
          <span className={styles.totalImagesLabel}>
            Total Items: <span className={styles.totalImagesValue}>
              {displayedTotal}
            </span>
          </span>
          
          <select
            className={styles.columnSelect}
            value={columnClass}
            onChange={(e) => onColumnClassChange(e.target.value)}
          >
            <option value="cols-2">2 Columns</option>
            <option value="cols-3">3 Columns</option>
            <option value="cols-4">4 Columns</option>
            <option value="cols-5">5 Columns</option>
            <option value="cols-6">6 Columns</option>
          </select>
        </div>
      </h2>
      
      {/* Loading state */}
      {loading ? (
        <div className={styles.loadingContainer}>
          <img src={Logo} alt="Loading" className={styles.loadingImage} />
        </div>
      ) : (
        /* Gallery content - pass columnClass to children instead of wrapping */
        children
      )}
    </div>
  );
};

export default ComfyOutputLayout; 